<template>
  <span
    class="audio-container"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
    }"
  >
    <span v-if="content.text" :id="`${content.key}-1`" @click.prevent="audioPlayerShow">{{ content.text }}</span>
    <img
      v-if="content.icon"
      :id="`${content.key}-2`"
      :src="content.icon"
      alt=""
      class="audio-icon" 
      @click.prevent="audioPlayerShow"/>
    <audioPlayer :dialogTitle="dialogTitle" :visible="dialogVisible" :audio_src="content.url" @dialogClose="audioPlayerHide"></audioPlayer>
  </span>
</template>
<script>
/*
音频
*/
import audioPlayer from "../popup/audioPlayer.vue";
export default {
  name: "text-audio",
  components: {
    audioPlayer
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogTitle: '播放音频',
      dialogVisible: false
    }
  },
  methods: {
    audioPlayerShow() {
      this.dialogVisible = true
    },
    audioPlayerHide() {
      this.dialogVisible = false
    },
  }
}
</script>

<style lang="scss" scoped>
.audio-container{
  cursor: pointer;
  .audio-icon{
    width: 20rem;
    height: 20rem;
    top: 4rem;
    position: relative;
  }
}
</style>